var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 16,
    height: 12,
    rx: 4,
    stroke: "#484964",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16L12 14",
    stroke: "#484964",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 5.14229C14.9035 5.48217 15.3709 5.56575 15.7108 5.32899C16.0507 5.09222 16.1343 4.62476 15.8975 4.28489L14.6667 5.14229ZM8.27819 4.04862C8.02082 4.37318 8.07528 4.84492 8.39984 5.10228C8.72439 5.35965 9.19613 5.30519 9.4535 4.98064L8.27819 4.04862ZM8.75 9V7H7.25V9H8.75ZM8.75 7C8.75 5.20508 10.2051 3.75 12 3.75V2.25C9.37665 2.25 7.25 4.37665 7.25 7H8.75ZM15.8975 4.28489C15.331 3.4717 14.5244 2.85606 13.5905 2.52421L13.0883 3.93762C13.7272 4.16467 14.2791 4.5859 14.6667 5.14229L15.8975 4.28489ZM13.5905 2.52421C12.6567 2.19236 11.6424 2.16091 10.6898 2.43426L11.1036 3.87607C11.7554 3.68904 12.4493 3.71056 13.0883 3.93762L13.5905 2.52421ZM10.6898 2.43426C9.73722 2.70762 8.89397 3.27209 8.27819 4.04862L9.4535 4.98064C9.87482 4.44933 10.4518 4.06311 11.1036 3.87607L10.6898 2.43426Z",
    fill: "#484964"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwIcon);
export default __webpack_public_path__ + "static/media/pwIcon.0550e30babc6d9f0b9b152f65a63bd9b.svg";
export { ForwardRef as ReactComponent };